import * as React from 'react';
import { SVGProps } from 'react';

const SvgParking = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.385 5H7v14h3.077v-4.667h2.308c2.546 0 4.615-2.092 4.615-4.667s-2.069-4.667-4.615-4.667zm.153 6.222h-2.462V8.111h2.462c.846 0 1.538.7 1.538 1.556s-.692 1.556-1.538 1.556z" />
  </svg>
);

export default SvgParking;
